import * as React from "react";
import { FunctionComponent } from "react";
import { getMoveOutcome, RuleExample } from "@mancala/core";
import MiniBoard from "../home/MiniBoard";
import { NextIcon } from "../Icons";

// A rule's example: the board before the move with the pit played marked, and after it with the landing pit marked.
// The board after the move comes from the engine.
const RuleBoard: FunctionComponent<{ example: RuleExample }> = ({ example }) => {
    if (example.pitIndex === undefined) {
        return <div className="rboard single"><MiniBoard board={example.board} /></div>;
    }
    const outcome = getMoveOutcome(example.board, example.pitIndex);
    return (
        <div className="rboard">
            <MiniBoard board={example.board} played={example.pitIndex} />
            <span className="arrow"><NextIcon /></span>
            <MiniBoard board={outcome.board} landed={outcome.path[outcome.path.length - 1]} />
            <style jsx>{`
                .rboard {
                    display: grid;
                    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
                    align-items: center;
                    gap: 8px;
                }
                .arrow {
                    color: var(--muted);
                    display: flex;
                }
                @media (max-width: 640px) {
                    .rboard {
                        grid-template-columns: minmax(0, 1fr);
                    }
                    .arrow {
                        justify-content: center;
                        transform: rotate(90deg);
                    }
                }
            `}</style>
        </div>
    );
};

export default RuleBoard;
